import type { ConsumerConfig } from '../index';
import logo from './logo.svg';

/**
 * Disney Cruise Line (disney_cruise) consumer configuration.
 *
 * Disney typography comes from the Inspire TWDC assets shared with idme-assets.
 * Other brand values retain IDMe defaults.
 *
 * The `disney_cruise` handle must match identically across all surfaces
 * (Theme::DisneyCruise, disney_cruise_logo.svg, .theme-disney_cruise, and the
 * idme-admin policy `theme` field) or that surface silently renders unbranded.
 */
export const disneyCruiseConfig: ConsumerConfig = {
  themeClass: 'theme-disney_cruise',
  logo: {
    src: logo,
    alt: 'Disney Cruise Line',
  },
  brand: {
    fontFamily: '"Inspire TWDC", Arial, Helvetica, sans-serif',
    colorPrimary: '#266aca', // IDMe default ($august)
    colorTextPrimary: '#2e3f51', // IDMe default ($ink)
    colorTextSecondary: '#757575', // IDMe default ($boulder)
  },
  legalIdIntro: {
    headingKey: 'legalId.consumerIntro.disney_cruise.heading',
    headingLineKeys: [
      'legalId.consumerIntro.disney_cruise.headingLine1',
      'legalId.consumerIntro.disney_cruise.headingLine2',
    ],
    supportingTextKey: 'legalId.consumerIntro.disney_cruise.supportingText',
    fallbackTextKey: 'legalId.consumerIntro.disney_cruise.fallback',
  },
};
